import CartFrame from "../Components/CartComponent/CartFrame";

function Cart() {
  return <CartFrame />;
}
export default Cart;
